import { Box, Typography } from '@mui/material'

function Reports() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Typography>Reports Page</Typography>
    </Box>
  )
}

export default Reports
